import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './contact-rms.reducer';

export const ContactRmsDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const contactRmsEntity = useAppSelector(state => state.contactRms.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="contactRmsDetailsHeading">
          <Translate contentKey="crawlerBackendApp.contactRms.detail.title">ContactRms</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="global.field.id">ID</Translate>
            </span>
          </dt>
          <dd>{contactRmsEntity.id}</dd>
          <dt>
            <span id="firstName">
              <Translate contentKey="crawlerBackendApp.contactRms.firstName">First Name</Translate>
            </span>
          </dt>
          <dd>{contactRmsEntity.firstName}</dd>
          <dt>
            <span id="lastName">
              <Translate contentKey="crawlerBackendApp.contactRms.lastName">Last Name</Translate>
            </span>
          </dt>
          <dd>{contactRmsEntity.lastName}</dd>
          <dt>
            <span id="company">
              <Translate contentKey="crawlerBackendApp.contactRms.company">Company</Translate>
            </span>
          </dt>
          <dd>{contactRmsEntity.company}</dd>
          <dt>
            <span id="kvk">
              <Translate contentKey="crawlerBackendApp.contactRms.kvk">Kvk</Translate>
            </span>
          </dt>
          <dd>{contactRmsEntity.kvk}</dd>
          <dt>
            <span id="email">
              <Translate contentKey="crawlerBackendApp.contactRms.email">Email</Translate>
            </span>
          </dt>
          <dd>{contactRmsEntity.email}</dd>
          <dt>
            <span id="phoneNumber">
              <Translate contentKey="crawlerBackendApp.contactRms.phoneNumber">Phone Number</Translate>
            </span>
          </dt>
          <dd>{contactRmsEntity.phoneNumber}</dd>
          <dt>
            <span id="message">
              <Translate contentKey="crawlerBackendApp.contactRms.message">Message</Translate>
            </span>
          </dt>
          <dd>{contactRmsEntity.message}</dd>
          <dt>
            <span id="fileContactPath">
              <Translate contentKey="crawlerBackendApp.contactRms.fileContactPath">File Contact Path</Translate>
            </span>
          </dt>
          <dd>{contactRmsEntity.fileContactPath}</dd>
          <dt>
            <span id="consent">
              <Translate contentKey="crawlerBackendApp.contactRms.consent">Consent</Translate>
            </span>
          </dt>
          <dd>{contactRmsEntity.consent ? 'true' : 'false'}</dd>
          <dt>
            <span id="checkSendEmail">
              <Translate contentKey="crawlerBackendApp.contactRms.checkSendEmail">Check Send Email</Translate>
            </span>
          </dt>
          <dd>{contactRmsEntity.checkSendEmail}</dd>
          <dt>
            <span id="type">
              <Translate contentKey="crawlerBackendApp.contactRms.type">Type</Translate>
            </span>
          </dt>
          <dd>{contactRmsEntity.type}</dd>
        </dl>
        <Button tag={Link} to="/contact-rms" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/contact-rms/${contactRmsEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default ContactRmsDetail;
